import { FileCode2 } from 'lucide-react';
import { Button } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { CreativeSubType, CreativeType, type Creative } from '../../model';
import { PreviewImage } from './PreviewImage';

export function CreativePreviewCell({
  creative,
  onPreview,
}: {
  creative: Creative;
  onPreview: (creative: Creative) => void;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      // Block-level so the cell does not reserve text descender space under image previews.
      className="border-border bg-background hover:bg-muted flex h-[52px] w-[72px] overflow-hidden rounded-md border p-0"
      aria-label={dashboardT('creatives.openPreview', { name: creative.name })}
      onClick={() => {
        onPreview(creative);
      }}
    >
      <CreativePreviewMedia creative={creative} />
    </Button>
  );
}

function CreativePreviewMedia({ creative }: { creative: Creative }) {
  if (creative.type === CreativeType.Display && creative.subType === CreativeSubType.Html) {
    return <span className="text-foreground text-[11px] font-semibold">HTML</span>;
  }
  if (creative.type === CreativeType.Display && creative.url) {
    return <PreviewImage key={creative.url} src={creative.url} />;
  }
  if (creative.type === CreativeType.Video && creative.thumbnailUrl) {
    return <PreviewImage key={creative.thumbnailUrl} src={creative.thumbnailUrl} />;
  }
  if (creative.type === CreativeType.Video && creative.url) {
    return (
      <video
        src={creative.url}
        preload="metadata"
        muted
        playsInline
        aria-hidden="true"
        className="pointer-events-none h-full w-full object-contain"
      />
    );
  }
  return <FileCode2 className="text-muted-foreground h-5 w-5" aria-hidden="true" />;
}
